import React from "react";

const ExitIntent = () => (
    <div>This will become the standard Exit Intent UI</div>
);

export default ExitIntent;
